// frontend/src/components/AreasSection.jsx
import React, { useState } from "react";

const areasData = {
  "NORTH GLASGOW": [
    "Maryhill — G20",
    "Springburn — G21",
    "Possilpark — G22",
    "Ruchill — G20",
    "Balornock — G21",
    "Robroyston — G33",
    "Bishopbriggs (outskirts) G64",
    "Milngavie (outskirts) G62",
  ],
  "SOUTH GLASGOW": [
    "Pollokshields — G41",
    "Strathbungo — G41",
    "Govanhill — G42",
    "Battlefield — G42",
    "Mount Florida — G42",
    "Shawlands — G41",
    "Langside — G42",
    "Cathcart — G44",
    "Newlands — G43",
    "Pollok — G53",
    "Nitshill — G53",
    "Giffnock (outskirts) — G46",
    "Newton Mearns (outskirts) — G77",
  ],
  "EAST GLASGOW": [
    "Dennistoun — G31",
    "Haghill — G31",
    "Carntyne — G32",
    "Shettleston — G32",
    "Baillieston — G69",
    "Easterhouse — G34",
    "Tollcross — G32",
    "Parkhead — G31",
    "Bridgeton — G40",
    "Calton — G40",
    "Dalmarnock — G40",
    "Coatbridge (outskirts) — ML5",
    "Airdrie (outskirts) — ML6",
  ],
  "WEST GLASGOW": [
    "Partick — G11",
    "Finnieston — G3",
    "Kelvingrove — G3",
    "Hillhead — G12",
    "Jordanhill — G13",
    "Anniesland — G13",
    "Scotstoun — G14",
    "Yoker — G14",
    "Govan — G51",
    "Ibrox — G51",
    "Cessnock — G51",
    "Drumchapel — G15",
    "Clydebank (outskirts) — G81",
    "Bearsden (outskirts) — G61",
  ],
  "CITY CENTRE": [
    "City Centre — G1–G5",
    "Merchant City — G1",
  ],
  "OUTSKIRTS / GREATER GLASGOW AREAS": [
    "Paisley",
    "Renfrew",
    "Clydebank",
    "Bishopbriggs",
    "Kirkintilloch",
    "Bearsden",
    "Milngavie",
    "Newton Mearns",
    "Giffnock",
    "Clarkston",
    "Cambuslang",
    "Rutherglen",
    "East Kilbride",
    "Hamilton",
    "Coatbridge",
    "Airdrie",
    "Erskine",
    "Johnstone",
    "Barrhead",
    "Lenzie",
  ],
};

const AreasSection = () => {
  const [openRegion, setOpenRegion] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleRegion = (region) => {
    setOpenRegion(openRegion === region ? null : region);
  };

  const filteredAreas = (areas) => {
    if (!searchTerm) return areas;
    return areas.filter((area) =>
      area.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <section id="areas" className="py-16 sm:py-20 md:py-24 bg-[#F3F4F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1D4ED8]">
            Areas We Cover
          </h2>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-[#1F2937] max-w-3xl mx-auto">
            At Portland Driving School, we cover many areas across London. Use
            the search bar or expand each region to find your area.
          </p>
        </div>

        <div className="mb-8 sm:mb-10 md:mb-12 max-w-md mx-auto relative">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search your area..."
            className="w-full px-4 sm:px-5 py-2.5 sm:py-3 pr-12 rounded-2xl border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-sm sm:text-base transition placeholder-gray-400"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 h-4 sm:h-5 w-4 sm:w-5 text-gray-400 pointer-events-none"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z"
            />
          </svg>
        </div>

        <div className="space-y-4 sm:space-y-6 md:space-y-8">
          {Object.entries(areasData).map(([region, areas]) => (
            <div
              key={region}
              className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => toggleRegion(region)}
                className="w-full px-4 sm:px-6 py-3 sm:py-4 text-left font-semibold text-base sm:text-lg md:text-xl text-gray-900 hover:bg-gray-100 transition flex justify-between items-center group"
              >
                {region}
                <div className="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-blue-100 text-blue-600 transition group-hover:bg-blue-200">
                  <span className="plus-icon text-lg sm:text-xl font-bold">
                    {openRegion === region ? "−" : "+"}
                  </span>
                </div>
              </button>

              <div
                className={`px-4 sm:px-6 pb-4 sm:pb-6 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 transition-all duration-300 ${
                  openRegion === region ? "block" : "hidden"
                }`}
              >
                {filteredAreas(areas).map((area, index) => (
                  <a
                    key={index}
                    href="#contact"
                    className="area-card text-sm sm:text-base md:text-lg py-2 px-3 sm:py-2.5 sm:px-3.5 rounded-lg bg-gray-100 text-gray-800 hover:bg-blue-100 transition text-center"
                  >
                    {area}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasSection;
